"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXirrBuckets = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucketHelper_1 = require("../../../utils/bucketHelper");
exports.getXirrBuckets = function (_a) {
    var buckets = _a.buckets;
    var limitedMeasureBuckets = bucketHelper_1.limitNumberOfMeasuresInBuckets(buckets, 1);
    var currentMeasureBucket = bucketHelper_1.findBucket(limitedMeasureBuckets, sdk_ui_1.BucketNames.MEASURES);
    var currentAttributeBucket = bucketHelper_1.findBucket(buckets, sdk_ui_1.BucketNames.ATTRIBUTE);
    var measureItem = bucketHelper_1.getAllMeasures(limitedMeasureBuckets)[0];
    var dateAttributeItem = bucketHelper_1.getDateItems(buckets)[0];
    return [
        tslib_1.__assign(tslib_1.__assign({}, currentMeasureBucket), { localIdentifier: sdk_ui_1.BucketNames.MEASURES, items: measureItem ? [measureItem] : [] }),
        tslib_1.__assign(tslib_1.__assign({}, currentAttributeBucket), { localIdentifier: sdk_ui_1.BucketNames.ATTRIBUTE, items: dateAttributeItem ? [dateAttributeItem] : [] }),
    ];
};
//# sourceMappingURL=xirrBucketHelper.js.map